/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SpaceDraft } from "./SpaceDraft";
export const SpaceDraftResponse = core.serialization.object({
    data: SpaceDraft,
});
